import { LeadPreviewContent } from "features/leads/components";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";
import type { DetailedLead } from "common/types";

import Certifications from "./Certifications";
import CurrentExperience from "./CurrentExperience";
import Education from "./Education";
import Experience from "./Experience";
import Languages from "./Languages";
import Skills from "./Skills";

interface MobileLayoutProps {
  lead: DetailedLead;
  profileId: string;
  isLoading: boolean;
}

export default function MobileLayout({
  lead,
  profileId,
  isLoading,
}: MobileLayoutProps) {
  const items = [
    {
      label: "Current position",
      component: (
        <CurrentExperience
          currentExperience={lead?.current_experience}
          isLoading={isLoading}
        />
      ),
    },
    {
      label: "Experience",
      component: (
        <Experience
          workExperience={lead?.work_experience}
          isLoading={isLoading}
        />
      ),
    },
    {
      label: "Education",
      component: (
        <Education education={lead?.education} isLoading={isLoading} />
      ),
    },
    {
      label: "License & certs",
      component: <Certifications certification={lead?.certifications} />,
    },
    {
      label: "Skills",
      component: <Skills skills={lead?.skills} />,
    },
    {
      label: "Languages",
      component: <Languages languages={lead?.languages} />,
    },
  ];

  return (
    <>
      <LeadPreviewContent initialState={profileId} mode="leadDetails" />
      <Accordion type="single" collapsible>
        {items.map(({ label, component }) => (
          <AccordionItem
            key={label}
            value={label}
            className="first:border-t border-b border-black-200 text-button-sm"
          >
            <AccordionTrigger className="px-4 py-2.5 gap-x-1.5">
              {label}
            </AccordionTrigger>
            <AccordionContent className="py-2 flex flex-col gap-y-3 px-4">
              {component}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
}
